import "@/instrument";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Sentry } from "@/instrument";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler?.(),
  onCaughtError: Sentry.reactErrorHandler?.(),
  onRecoverableError: Sentry.reactErrorHandler?.(),
});
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
